var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#FCEAF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 26.6667C47.3332 26.6667 53.3332 32.6667 53.3332 40.0001C53.3332 47.3334 47.3332 53.3334 39.9998 53.3334C32.6665 53.3334 26.6665 47.3334 26.6665 40.0001C26.6665 32.6667 32.6665 26.6667 39.9998 26.6667ZM39.9998 29.3334C37.4665 29.3334 35.1998 30.1334 33.4665 31.6001L48.3998 46.5334C49.7332 44.6667 50.6665 42.4001 50.6665 40.0001C50.6665 34.1334 45.8665 29.3334 39.9998 29.3334ZM46.5332 48.4001L31.5998 33.4667C30.1332 35.2001 29.3332 37.4667 29.3332 40.0001C29.3332 45.8667 34.1332 50.6667 39.9998 50.6667C42.5332 50.6667 44.7998 49.8667 46.5332 48.4001Z",
    fill: "#221C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.235dd485d8b90bef25b04e48b4be77a4.svg";
export { ForwardRef as ReactComponent };